import React, { Component, lazy, Suspense } from 'react';
import { createHashHistory } from 'history';
import { Routes, Route, Switch, useHistory } from "react-router-dom";
import { connect } from 'react-redux';
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';
import LoginSuccessRedirectPage from '../../../Modules/Dashboard/Pages/LoginSuccessRedirectPage';
const Dashboard = lazy(() => import('../Pages/Dashboard'))
const DashboardV2 = lazy(() => import('../Pages/DashboardV2'))
const DashboardProcurement = lazy(() => import('../Pages/DashboardProcurement'))
const BillingCounterDashboard = lazy(() => import('../Pages/BillingCounterDashboard'))
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Helper function to determine which dashboard to show
function getDashboardType(storeDetails, orgDetails) {
    const { store_type, is_procurement_hub, can_sell } = storeDetails;
    const { allow_main_store } = orgDetails;
    // console.log("storeDetails", storeDetails);
    // console.log("orgDetails", orgDetails);

    // MAIN store always shows procurement dashboard
    if (store_type === 'MAIN') {
        return 'CENTRAL_HUB';
    }

    // BRANCH store logic
    if (store_type === 'BRANCH') {
        if (allow_main_store) {
            return 'V2';
        } else {
            if (is_procurement_hub) {
                return 'CENTRAL_HUB';
            } else {
                return 'V2';
            }
        }
    }

    // COST_CENTER and any other store types show V2
    if (store_type === 'COST_CENTER') {
        return 'V2';
    }

    // Default fallback
    return 'V2';
}

// Component to render the appropriate dashboard
function DashboardRoute({ currentStore }) {
    // console.log("currentStore", currentStore);
    const history = useHistory();

    // Prepare store and org details
    const storeDetails = currentStore ? {
        store_type: currentStore.store_type,
        is_procurement_hub: currentStore.is_procurement_hub,
        can_sell: currentStore.can_sell
    } : {
        store_type: null,
        is_procurement_hub: false,
        can_sell: false
    };

    const orgDetails = {
        allow_main_store: currentStore?.orgMetaStoreRelation?.allow_main_store
    };

    // Determine which dashboard to show
    const dashboardType = getDashboardType(storeDetails, orgDetails);

    // Map dashboard type to component
    const getDashboardComponent = () => {
        // console.log("[DashboardRoute] Rendering dashboard type:", dashboardType);
        switch (dashboardType) {
            case 'CENTRAL_HUB':
                return <DashboardProcurement history={history} />;
            case 'V2':
            default:
                return <DashboardV2 history={history} />;
        }
    };

    return (
        <Switch>
            <Route
                exact
                path="/"
                render={() => (
                    <PermissionGuard2 history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent', 'agent_staff']}>
                        <LoginSuccessRedirectPage history={history} />
                    </PermissionGuard2>
                )}
            />
            <Route
                exact
                path="/:lng/dashboard"
                render={() => (
                    <PermissionGuard2 history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
                        <Suspense fallback={<Loading />}>
                            {getDashboardComponent()}
                        </Suspense>
                    </PermissionGuard2>
                )}
            />
            <Route
                exact
                path="/:lng/dashboard/billing-counter"
                render={() => (
                    <PermissionGuard2 history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
                        <Suspense fallback={<Loading />}>
                            <BillingCounterDashboard history={history} />
                        </Suspense>
                    </PermissionGuard2>
                )}
            />
        </Switch>
    );
}
const mapStateToProps = (state) => ({
    currentStore: state.StoreReducer.currentStore,
});

export default connect(mapStateToProps)(DashboardRoute);

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
